export default __webpack_public_path__ + "static/media/3233 spice rack D top.41a70729.png";